import * as types from "../../ActionType";

const initState = {
    supppliers: [],
    loadingSupppliers: true
}

const SupplyReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_SUPPLY:
            return { ...state, loadingSupppliers: true }
        case types.GET_SUPPLIERS:
            return { ...state, supppliers: action.payload, loadingSupppliers: false }
        case types.DELETE_SUPPLY:
            return { ...state}
        case types.EDIT_SUPPLY:
            return { ...state, loadingSupppliers: true }
        default:
            return state;
    }
};

export default SupplyReducer;
